import { Z16ProOngletDefautService } from './services/z16pro.onglet-defaut.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Z16ProEntiteService } from './services/z16pro.entite.service';
import { Z16ProChampService } from './services/z16pro.champ.service';
import { Z16ProOngletService } from './services/z16pro.onglet.service';
import { Z16ProModuleMappingService } from './services/z16pro.module-mapping.service';
import { Z16ProSectionService } from './services/z16pro.section.service';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [],
    providers: [
        Z16ProEntiteService,
        Z16ProChampService,
        Z16ProOngletService,
        Z16ProSectionService,
        Z16ProOngletDefautService,
        Z16ProModuleMappingService
    ]
})
export class Z16ProModule { }
